import React, { useState, useEffect } from "react";
import { ConfigProvider } from "antd";
import "./App.css";
import "antd/dist/antd.css";
import "./theme/vercel-dashboard.css";
import UserContext from "./components/utils/UserContext";
import AuthUser from "./components/utils/auth_user";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Wrapper from "./pages/wrapper";
import Projects from "./pages/dashboard/index";
import Project from "./pages/project/index";
import YoutubeAnalyticsPage from "./pages/project/youtube-analytics";
import PayoutsDetail from "./pages/payouts/index";
import DemoDashboard from "./pages/demo-dashboard";
import DemoProjectPage from "./pages/demo-dashboard/DemoProjectPage";
import YoutubeAnalyticsMockPage from "./pages/dev/YoutubeAnalyticsMockPage";
import { LeadCaptureProvider } from "./components/lead-capture";
import ReactGA from "react-ga4";
import { hotjar } from "react-hotjar";

const App = () => {
  const [auth_user, updateAuthUser] = useState({});
  const updateUser2 = (auth) => {
    updateAuthUser(auth);
  };

  ReactGA.initialize("G-STNX61MJYM");
  ReactGA.send("pageview");
  useEffect(() => {
    hotjar.initialize(3309419, 6);
  }, []);
  return (
    <div className="App">
      <ConfigProvider componentSize="middle">
        <UserContext.Provider>
          <AuthUser show={false} parentMethod={updateUser2}></AuthUser>

          <BrowserRouter>
            <LeadCaptureProvider>
              <Switch>
                <Route
                  exact
                  path="/demo/project/:id"
                  component={DemoProjectPage}
                />
                <Route exact path="/demo" component={DemoDashboard} />
                <Route
                  exact
                  path="/dev/youtube-analytics-mock"
                  component={YoutubeAnalyticsMockPage}
                />
                <Route
                  path="/"
                  render={() => (
                    <Wrapper auth_user={auth_user}>
                      <Route
                        exact
                        path="/"
                        render={() => <Projects auth_user={auth_user} />}
                      />
                      <Route
                        exact
                        path="/project/:id"
                        render={() => <Project auth_user={auth_user} />}
                      />
                      <Route
                        exact
                        path="/project/:id/youtube-analytics"
                        render={() => (
                          <YoutubeAnalyticsPage auth_user={auth_user} />
                        )}
                      />
                      <Route
                        exact
                        path="/payouts"
                        render={() => <PayoutsDetail auth_user={auth_user} />}
                      />
                    </Wrapper>
                  )}
                />
              </Switch>
            </LeadCaptureProvider>
          </BrowserRouter>
        </UserContext.Provider>
      </ConfigProvider>
    </div>
  );
};

export default App;
